import { render, staticRenderFns } from "./AssetTab.vue?vue&type=template&id=62e3f59a&"
import script from "./AssetTab.vue?vue&type=script&lang=js&"
export * from "./AssetTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports